import { render, staticRenderFns } from "./ModalEditarMetodoRequisicao.vue?vue&type=template&id=5575e1ca&scoped=true"
import script from "./ModalEditarMetodoRequisicao.vue?vue&type=script&lang=js"
export * from "./ModalEditarMetodoRequisicao.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarMetodoRequisicao.vue?vue&type=style&index=0&id=5575e1ca&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5575e1ca",
  null
  
)

export default component.exports